import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
  },
  state: {
    app: {}
  },
  mutations: {
  },
  actions: {
  },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js